// UnableLogin页面相关的类型定义和枚举

export enum LoginIssueType {
  FORGOT_PASSWORD = 'forgot_password',
  TWO_FA_AUTH = '2fa_auth',
  CHANGE_PHONE = 'change_phone',
  CHANGE_EMAIL = 'change_email',
}

export interface LoginIssue {
  description: string
  issueType: LoginIssueType
}